const ClienteIdentificadorService = {
  cliente: () => {
    let subdomain = window.location.host.split(".")[1]
      ? window.location.host.split(".")[0]
      : false;
    return subdomain;
  },
};

export default ClienteIdentificadorService;
